import React from 'react';
import { Mark } from '@mantine/core';

interface SearchHighlightProps {
  text: string;
  searchTerm: string;
}

export const SearchHighlight: React.FC<SearchHighlightProps> = ({ text, searchTerm }) => {
  if (!searchTerm || !searchTerm.trim()) {
    return <span>{text}</span>;
  }

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, index) => {
        if (regex.test(part)) {
          return (
            <Mark key={index} color="yellow" bg="yellow.1">
              {part}
            </Mark>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};